<p-fieldset legend="Progress" styleClass="progress_fieldSet" [toggleable]="true">
    <app-training-plan-progress></app-training-plan-progress>
</p-fieldset>
<br>

<p-fieldset legend="Training Requirements" [toggleable]="true">
    <div>
        <app-training-plan-requirements></app-training-plan-requirements>
    </div>
</p-fieldset>

